import { Check } from "lucide-react";
import { Btn } from "./kit";
import { TextInput } from "./Form";

export const STATUSES = [
  ["present", "Present", "bg-[#39FF14] text-[#0A0E1A]"],
  ["late", "Late", "bg-amber-300 text-[#0A0E1A]"],
  ["excused", "Excused", "bg-[#00E5FF] text-[#0A0E1A]"],
  ["absent", "Absent", "bg-[#FF3B30] text-white"],
  ["injured", "Injured", "bg-orange-400 text-[#0A0E1A]"],
];

const PlayerRow = ({ p, row, onChange }) => (
  <li data-testid={`att-row-${p.id}`} className="grid gap-3 border-t border-[#1E293B] px-4 py-3 md:grid-cols-[minmax(160px,1fr)_auto_minmax(160px,1fr)] md:items-center">
    <p className="truncate text-sm font-semibold text-white"><span className="mr-2 font-mono-gd text-xs text-slate-400">#{p.jersey ?? "–"}</span>{p.name}</p>
    <div className="flex flex-wrap gap-1.5">
      {STATUSES.map(([val, label, on]) => (
        <button key={val} type="button" data-testid={`att-${p.id}-${val}`} onClick={() => onChange({ ...row, status: val })}
          className={`rounded-full px-3 py-1.5 font-mono-gd text-[11px] font-bold uppercase transition-colors ${row.status === val ? on : "bg-[#162032] text-slate-300 hover:text-white"}`}>
          {label}
        </button>
      ))}
    </div>
    <TextInput data-testid={`att-note-${p.id}`} value={row.note ?? ""} onChange={(e) => onChange({ ...row, note: e.target.value })} placeholder="Note (optional)" className="py-2" />
  </li>
);

/** Roster grid for one practice/game. rows: { [player_id]: { status, note } } */
export const AttendanceTaker = ({ players, rows, setRows, onSave, busy }) => {
  const marked = Object.values(rows).filter((r) => r.status).length;
  const allPresent = () => setRows(Object.fromEntries(players.map((p) => [p.id, { ...rows[p.id], status: "present" }])));
  return (
    <div className="overflow-hidden rounded-2xl border border-[#1E293B] bg-[#0F172A]">
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3">
        <p data-testid="att-marked-count" className="font-mono-gd text-xs uppercase tracking-wider text-slate-400">{marked} / {players.length} marked</p>
        <div className="flex gap-2">
          <Btn type="button" variant="ghost" onClick={allPresent} data-testid="att-all-present" className="px-4 py-2 text-xs"><Check className="h-3.5 w-3.5" />All present</Btn>
          <Btn type="button" onClick={onSave} disabled={busy || !marked} data-testid="att-save" className="px-4 py-2 text-xs">{busy ? "Saving…" : "Save attendance"}</Btn>
        </div>
      </div>
      <ul>{players.map((p) => <PlayerRow key={p.id} p={p} row={rows[p.id] ?? {}} onChange={(r) => setRows({ ...rows, [p.id]: r })} />)}</ul>
    </div>
  );
};
